var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import Dino from './assets/Dino.svg';
var Wrapper = styled.div.withConfig({ displayName: "Wrapper", componentId: "sc-1f0o2pq" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n"], ["\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n"])));
var Title = styled.span.withConfig({ displayName: "Title", componentId: "sc-mg5c0o" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 32px;\n  margin-top: 32px;\n  color: ", ";\n"], ["\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 32px;\n  margin-top: 32px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
});
var Subtitle = styled.span.withConfig({ displayName: "Subtitle", componentId: "sc-hb3wwn" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  margin-top: 8px;\n  color: ", ";\n"], ["\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  margin-top: 8px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
});
var NoPrintablesBanner = function (_a) {
    var props = __rest(_a, []);
    return (_jsxs(Wrapper, __assign({ "data-testid": 'banner' }, props, { children: [_jsx(Dino, { "data-testid": 'dino' }, void 0), _jsx(Title, { children: "There are no printables here yet" }, void 0), _jsx(Subtitle, { children: "Please check back soon." }, void 0)] }), void 0));
};
export default NoPrintablesBanner;
var templateObject_1, templateObject_2, templateObject_3;
